{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://modules/purchase-period",
  "title": "Purchase Period",
  "description": "ESPP purchase period — structural field catalog for array items.",
  "type": "object",
  "properties": {
    "purchasePeriodIndex": {
      "type": "integer",
      "title": "Index",
      "widget": "hidden"
    },
    "purchasePeriodId": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "periodStartDate": {
      "type": "string",
      "title": "Start Period",
      "format": "date"
    },
    "periodEndDate": {
      "type": "string",
      "title": "End Period",
      "format": "date"
    },
    "enrollmentWindowStartDate": {
      "type": "string",
      "title": "Enroll Start",
      "format": "date"
    },
    "enrollmentWindowEndDate": {
      "type": "string",
      "title": "Enroll End",
      "format": "date"
    },
    "changeWindowStartDate": {
      "type": "string",
      "title": "Change Start",
      "format": "date"
    },
    "changeWindowEndDate": {
      "type": "string",
      "title": "Change End",
      "format": "date"
    },
    "purchaseDate": {
      "type": "string",
      "title": "Purchase Date",
      "format": "date"
    },
    "purchasePrice": {
      "type": "number",
      "title": "Purchase Price",
      "minimum": 0,
      "inputPrecision": 4,
      "displayPrecision": 4,
      "displayFormat": "currency"
    }
  }
}
